var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "coupon-container", class: _vm.setResponsiveClass },
    [
      _c("input", {
        ref: "couponInput",
        staticClass: "input text-input coupon-input",
        attrs: {
          placeholder: "Got a coupon code? Enter it here",
          "aria-label": "input coupon code"
        },
        on: {
          change: _vm.handleChangeCouponInput,
          focus: _vm.handleChangeCouponInput
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { ref: "couponContainer", staticClass: "coupon-message-container" },
        [
          _vm.showLoader()
            ? _c("BaseLoader", { attrs: { type: "input-field" } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "coupon-message", class: _vm.messageClass },
            [
              _vm._v("\n\t\t\t" + _vm._s(_vm.displayMessage()) + "\n\n\t\t\t"),
              _vm.applied
                ? _c(
                    "div",
                    { staticClass: "coupon-icon-wrapper" },
                    [
                      _c("BaseIcon", {
                        attrs: { icon: "checkCircleLight", size: "2x" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "store-txt-color full-width",
                  attrs: { id: "redemptions-available" }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.getAvailableRedemptionsTxt()) +
                      "\n\t\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "store-txt-color" },
                [
                  _vm.items
                    ? _c("menu-item-rows", {
                        attrs: { hasDiscount: true, items: _vm.items }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.applied
            ? _c("a", { on: { click: _vm.handleRemoveCoupon } }, [
                _vm._v("Remove")
              ])
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f1918ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f1918ca","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/CouponField.vue
// module id = null
// module chunks = 